export abstract class ConstantsService {
    [key: string]: any
}

export function ConstantsServiceFactory($injector: angular.auto.IInjectorService) {
    return $injector.get('Constants');
}

export const ConstantsServiceProvider = {
    provide: ConstantsService,
    useFactory: ConstantsServiceFactory,
    deps: ['$injector']
};
